// Where you are: the room (a dropdown of the rooms the company has), then for Jobs and Bids the one job or bid.
// On the desk both steps are always open, and that is it. On the phone it is one line that opens into the same two.
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { STAGES } from '@tradeview/shared';
import { navFor } from '@tradeview/core';
import { useAuth } from '../auth';
import { useRoom, doorOf } from './room';

export function RoomBand({ variant }: { variant: 'phone' | 'desk' }) {
  const { session } = useAuth();
  const { rooms, room, project, projects, loading, enterRoom, enterProject } = useRoom();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const stage = project ? (STAGES[project.stage as keyof typeof STAGES]?.label ?? project.stage) : '';
  const sub = project ? (project.bid ? stage : `${stage}${project.pctComplete != null ? ` · ${Math.round(project.pctComplete)}%` : ''}`) : '';
  // The picker is the criteria only: Jobs, Bids, Service, Warehouse, Company (jb: fifty jobs and fifty bids do not
  // belong in a dropdown). Jobs and Bids land on the room's schedule, and the row you open there takes you into the one.
  const value = room ? room.id : '';
  const pick = (id: string) => {
    const r = rooms.find(x => x.id === id); if (!r) return; enterRoom(r.id); setOpen(false);
    const wide = r.picks ? navFor('desktop', session?.role ?? null, session?.entitlements ?? null).find(n => n.room === r.id && n.scope === 'room')?.route : null;
    nav(r.picks ? (wide ?? '/') : doorOf(r));
  };
  void enterProject; void projects;
  const phone = variant === 'phone';
  const picker = (
    <select aria-label="Where you are" value={value} onChange={e => pick(e.target.value)} className={`field-in min-h-10 font-head font-bold text-[13.5px] ${value ? 'border-accent' : 'border-line'}`}>
      {!value && <option value="">{loading ? 'Loading…' : 'Pick a room'}</option>}
      {rooms.map(r => <option key={r.id} value={r.id}>{r.label}</option>)}
    </select>
  );
  if (!phone) return picker;
  const word = room ? (room.picks ? room.label.replace(/s$/, '') : room.label) : '';
  return (
    <div className="mx-3.5 mb-1.5 flex flex-col gap-1.5">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="w-full text-left flex items-center gap-2.5 rounded-[12px] border border-accent bg-accent-soft px-3 py-2">
        {room ? <>
          <span className="font-disp font-bold text-[11px] tracking-[.1em] uppercase text-accent-ink bg-accent rounded-[6px] px-2 py-0.5">{word}</span>
          <span className="min-w-0 flex-1 leading-tight"><b className="block font-head font-bold text-[13.5px] truncate">{project ? project.name : room.label}</b>{sub && <small className="block text-[11.5px] text-accent">{sub}</small>}</span>
        </> : <span className="min-w-0 flex-1 leading-tight"><b className="block font-head font-bold text-[13.5px]">{loading ? 'Loading…' : 'Pick a room'}</b><small className="block text-[11.5px] text-muted">a job, a bid, service, the warehouse, the company</small></span>}
        <span className="text-[12px] text-muted shrink-0">change</span>
      </button>
      {open && picker}
    </div>
  );
}
